<template>
  <footer class="customFooter columns is-centered hero is-light">
    <Logo />
  </footer>
</template>

<script>
import Logo from '@/components/Logo/LogoComponent.vue'

export default {
  components: {
    Logo
  }
}
</script>

<style lang="scss" scoped>
</style>
